import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"
import { SCHEDULE_TYPE_FIELDS } from "../../controller/get-project-schedules"

export const getProjectScopedSchedules = api(async function getProjectScopedSchedules({ projectId, showAll }) {
    if (!projectId) return null
    return query(
        gql`
            query GetProjectScopedSchedules($projectId: String!, $showAll: Boolean) {
                getProjectScopedSchedules(projectId: $projectId, showAll: $showAll) {
                    ${SCHEDULE_TYPE_FIELDS}
                    draftStatus
                    seedSource
                }
            }
        `,
        { projectId, showAll },
        { returns: "getProjectScopedSchedules" }
    )
})
